export const MAIN_TITLE = 'main-title';
